<template>
  <v-card
    class="mt-5 pb-4 helmi-card"
    outlined
    elevation="0"
  >
    <v-card-text>
      <div class="helmi-card-title mb-2">
        Välityspalkkion tiedot
      </div>
      <v-row v-if="!!property">
        <v-col class="py-0">
          <p class="mb-0 mt-2">
            Välityspalkkio: <b>{{ total / 100 | currency }}</b><br>
            Viitenumero: <b>{{ reference }}</b><br>
            IBAN: <b>{{ property.companyBankAccounts[0].iban }}</b><br>
            BIC: <b>{{ property.companyBankAccounts[0].bic }}</b>
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    total: {
      type: Number,
      default: () => 0,
    },
    reference: {
      type: String,
      default: () => '',
    },
    property: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
